const STEPS = {
    product: [
        {
            title: 'Brands fund a campaign',
            body: 'A brand picks a niche, sets a budget, and chooses how much they\'ll pay per like, comment, share, and view. The budget sits in escrow.',
        },
        {
            title: 'Verified creators apply and post',
            body: 'Verified creators on Instagram or TikTok apply, get approved, and post the brief on their own channels — no minimum follower count.',
        },
        {
            title: 'We track engagement and pay out',
            body: 'PostPaid reads engagement directly from each platform. As real interactions come in, the creator\'s earnings accrue and the brand\'s escrow draws down — automatically.',
        },
    ],
    brand: [
        {
            title: 'Sign up and fund your campaign',
            body: 'Create a business account in minutes. Fund the campaign budget you\'re comfortable with — that money sits in escrow until interactions are verified.',
        },
        {
            title: 'Set per-interaction prices and approve creators',
            body: 'Decide what you\'ll pay per like, comment, share, and view. Browse applications from creators who match your niche and approve the ones you want.',
        },
        {
            title: 'Pay only for engagement that actually happened',
            body: 'We pull engagement data directly from Instagram and TikTok. You only pay for interactions we can verify — nothing self-reported.',
        },
    ],
    creator: [
        {
            title: 'Connect your social accounts',
            body: 'Sign up free, then connect Instagram or TikTok. We use the platforms\' own data to verify your audience and engagement.',
        },
        {
            title: 'Browse campaigns that fit you',
            body: 'Pick from active campaigns in your niche. Apply with a quick pitch — no agency middlemen, no waiting weeks.',
        },
        {
            title: 'Post, earn, withdraw',
            body: 'Post the brief on your channel. Earnings accrue per verified like, comment, share, and view. Withdraw in EUR or USD whenever you want.',
        },
    ],
}

function HowItWorks({ variant = 'product', title }) {
    const steps = STEPS[variant] || STEPS.product
    const heading = title || (variant === 'product' ? 'How PostPaid works' : variant === 'brand' ? 'How it works for brands' : 'How it works for creators')

    return (
        <div className="how-it-works-steps" id="how-it-works">
            <span className="mono-label" style={{ display: 'block', textAlign: 'center' }}>how it works</span>
            <h2 className="text-center" style={{ marginBottom: '3rem' }}>{heading}</h2>
            <div className="how-it-works-steps__grid" data-reveal-stagger>
                {steps.map((step, i) => (
                    <div key={i} className="how-it-works-steps__card">
                        <div className="step-number">0{i + 1}</div>
                        <h3 className="how-it-works-steps__step-title">{step.title}</h3>
                        <p className="how-it-works-steps__step-body">{step.body}</p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default HowItWorks
